import createReduxForm from './createReduxForm';
import plain from './structure/plain';
export default createReduxForm(plain);import createReduxForm from './createReduxForm';
import plain from './structure/plain';
export default createReduxForm(plain);